<template>
  <button @click="login()" type="button" class="w3-button w3-text-theme">
    <font-awesome-icon :icon="['fal', 'thumbs-up']" />  <span> ({{convo.meta.numLikes}})</span>
  </button> 
</template>

<script>
  import EndorseButtonNonauth from "./EndorseButtonNonauth.ts";

  export default EndorseButtonNonauth;
</script>
